import { useLocation } from "react-router-dom";
import { ProductList } from "components/ProductList";
import Banner from "components/Banner";
import Blog from "components/Blog";
import Collections from "components/Collections"

export default function Home() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryParam = queryParams.get("category");

  return (
    <>
      {categoryParam === "Blanketi" && (
        <ProductList tag="Blanketi" title="Blanketi Collection" />
      )}
      {categoryParam === "Dhahabu" && (
        <ProductList tag="Dhahabu" title="Dhahabu Collection" />
      )}
      {categoryParam === "KCB" && (
        <ProductList tag="KCB" title="Corporate" />
      )}
      {categoryParam === "Chakata" && (
        <ProductList tag="Chakata" title="Chakata Collection" />
      )}
      {categoryParam === "Athleisure" && (
        <ProductList tag="Athleisure" title="Athleisure" />
      )}
      {categoryParam === "Afro" && (
        <ProductList tag="Afro" title="Afro Collection" />
      )}
      {categoryParam === "CKB" && (
        <ProductList tag="CKB" title="CKB Collection" />
      )}

      <Collections />
      <Banner /> 
      <Blog />
    </>
  );
}
